const scheduleIdle =
    typeof window !== "undefined" && typeof window.requestIdleCallback === "function"
        ? (cb) => window.requestIdleCallback(cb, { timeout: 500 })
        : (cb) => setTimeout(cb, 16)

const cancelIdle =
    typeof window !== "undefined" && typeof window.cancelIdleCallback === "function"
        ? (id) => window.cancelIdleCallback(id)
        : (id) => clearTimeout(id)

export { scheduleIdle, cancelIdle }
